import { Grid } from '@mui/material';
import PropTypes from 'prop-types';

const PriceGrid = ({ children }) => (
  <Grid
    justifyContent="center"
    alignItems="center"
    sx={{
      display: 'flex',
      height: '40px',
      backgroundColor: '#DFE9F1',
      p: '6px 16px',
      mt: '3vh',
      borderRadius: '6px'
    }}>
    {children}
  </Grid>
);

PriceGrid.propTypes = {
  children: PropTypes.node
};

export default PriceGrid;
